// Indicador de progresso (stepper) para as etapas do orçamento

import React from "react";
import { HiUser, HiCalculator, HiPencil, HiCheckCircle } from "react-icons/hi";

interface Step {
  number: number;
  title: string;
  icon: React.ReactNode;
}

const steps: Step[] = [
  { number: 1, title: "Identificação", icon: <HiUser className="w-5 h-5" /> },
  { number: 2, title: "Valores", icon: <HiCalculator className="w-5 h-5" /> },
  { number: 3, title: "Assinatura", icon: <HiPencil className="w-5 h-5" /> },
  {
    number: 4,
    title: "Confirmação",
    icon: <HiCheckCircle className="w-5 h-5" />,
  },
];

interface OrcamentoProgressProps {
  currentStep: number;
  maxStepReached?: number;
  onStepClick?: (step: number) => void;
}

export const OrcamentoProgress: React.FC<OrcamentoProgressProps> = ({
  currentStep,
  maxStepReached = 1,
  onStepClick,
}) => {
  return (
    <div className="bg-gray-50 py-8 border-y border-gray-200">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="flex items-center justify-between relative">
          {/* Linha de progresso */}
          <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200 -z-10">
            <div
              className="h-full bg-[#4760e0] transition-all duration-500 ease-out"
              style={{
                width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
              }}
            />
          </div>

          {/* Steps */}
          {steps.map((step) => {
            const isCompleted = currentStep > step.number;
            const isCurrent = currentStep === step.number;
            const isActive = currentStep >= step.number;
            const isClickable = step.number <= maxStepReached && !!onStepClick;

            return (
              <div
                key={step.number}
                className="flex flex-col items-center gap-2"
              >
                {/* Círculo do step */}
                <button
                  type="button"
                  onClick={() => isClickable && onStepClick!(step.number)}
                  disabled={!isClickable}
                  className={`
                    flex items-center justify-center w-10 h-10 rounded-full
                    border-2 transition-all duration-300 relative z-10
                    ${
                      isCompleted
                        ? "bg-[#4760e0] border-[#4760e0] text-white"
                        : isCurrent
                          ? "bg-white border-[#4760e0] text-[#4760e0] shadow-lg scale-110"
                          : isActive
                            ? "bg-[#4760e0] border-[#4760e0] text-white"
                            : "bg-white border-gray-300 text-gray-400"
                    }
                    ${
                      isClickable
                        ? "cursor-pointer hover:scale-105 hover:shadow-md"
                        : "cursor-default"
                    }
                  `}
                >
                  {isCompleted ? (
                    <HiCheckCircle className="w-6 h-6" />
                  ) : (
                    step.icon
                  )}
                </button>

                {/* Título */}
                <span
                  className={`
                    text-xs md:text-sm font-medium text-center transition-all
                    ${
                      isCurrent
                        ? "text-[#4760e0] font-bold"
                        : isActive
                          ? "text-gray-700"
                          : "text-gray-400"
                    }
                  `}
                >
                  {step.title}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
